import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sector-list-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="container mx-auto px-4 py-4">
      <!-- Back Button Skeleton -->
      <div class="flex items-center justify-start mb-4 animate-pulse">
        <div class="h-10 w-24 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
      </div>

      <div class="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-6 animate-pulse">
        <!-- Header Skeleton -->
        <div class="mb-6">
          <div class="h-7 bg-gray-200 dark:bg-gray-700 rounded w-64 mb-2"></div>
          <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-48"></div>
        </div>

        <!-- Filters Section Skeleton -->
        <div class="mb-6">
          <div class="flex flex-col md:flex-row gap-4">
            <!-- Market Cap Filter Skeleton -->
            <div class="flex-1">
              <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-2"></div>
              <div class="h-11 bg-gray-200 dark:bg-gray-700 rounded"></div>
            </div>

            <!-- Discount Filter Skeleton -->
            <div class="flex-1">
              <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-20 mb-2"></div>
              <div class="h-11 bg-gray-200 dark:bg-gray-700 rounded"></div>
            </div>
          </div>
        </div>

        <!-- Table Skeleton -->
        <div class="bg-white dark:bg-gray-800 rounded-lg overflow-hidden">
          <div class="overflow-x-auto">
            <table class="w-full">
              <!-- Skeleton Header -->
              <thead class="bg-gray-50 dark:bg-gray-700">
                <tr>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-8 mx-auto"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-20"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-24 mx-auto"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-24 mx-auto"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-20 mx-auto"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-20 mx-auto"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-20 mx-auto"></div>
                  </th>
                  <th class="px-3 py-3">
                    <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-24 mx-auto"></div>
                  </th>
                </tr>
              </thead>

              <!-- Skeleton Body -->
              <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                <tr *ngFor="let item of [0,1,2,3,4,5,6,7,8,9]" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                  <!-- Watchlist Icon Column -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-6 w-6 bg-gray-200 dark:bg-gray-600 rounded mx-auto"></div>
                  </td>

                  <!-- Company Column -->
                  <td class="px-3 py-3 whitespace-nowrap">
                    <div class="flex items-center space-x-2">
                      <div class="h-10 w-10 bg-gray-200 dark:bg-gray-600 rounded"></div>
                      <div>
                        <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16 mb-1"></div>
                        <div class="h-3 bg-gray-200 dark:bg-gray-600 rounded w-24"></div>
                      </div>
                    </div>
                  </td>

                  <!-- Current Price -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16 mx-auto"></div>
                  </td>

                  <!-- Sticker Price -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-16 mx-auto"></div>
                  </td>

                  <!-- Discount -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12 mx-auto"></div>
                  </td>

                  <!-- WSY Score -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-6 w-10 bg-gray-200 dark:bg-gray-600 rounded mx-auto"></div>
                  </td>

                  <!-- Mgmt Score -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-6 w-10 bg-gray-200 dark:bg-gray-600 rounded mx-auto"></div>
                  </td>

                  <!-- Growth Score -->
                  <td class="px-3 py-3 whitespace-nowrap text-center">
                    <div class="h-6 w-10 bg-gray-200 dark:bg-gray-600 rounded mx-auto"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .animate-pulse {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: .5;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectorListSkeletonComponent {}
